// 建立配置本地存储
const state = {
    configdata: {}, //字典集合
};
const mutations = {
    configdata: (state, obj) => {
        state.configdata = obj;
    },
};

const actions = {
    async setDateConfig({ commit }) {
        await createGroupCash();
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};